import React from 'react';
import moment from 'moment';
import { EMOJIS } from '../utils';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { SET_RAISE_HAND } from 'store/VideoRoom/videoRoomAction';
import {
  HAND_RAISED,
  HAND_UNRAISED,
} from 'store/ParticipantsList/participantsListAction';
export default function useSignal({ room }) {
  const [listOfMessages, setListOfMessages] = React.useState([]);
  const state = useSelector((state) => state.videoRoomReducer);
  const dispatch = useDispatch();
  //const [isActive, isSetActive] = useState(false);

  const sendSignal = React.useCallback(
    (data, type, active) => {
      console.log('sendSignal from userSignal', data);
      if (room) {
        console.log('room', room);
        room.signal({ type: type, data: data }).catch((e) => e);
      }
      dispatch({ type: SET_RAISE_HAND, payload: active });
      //isSetActive(active);
    },
    [room, state.raiseHand]
  );

  const signalListener = React.useCallback(({ data, isSentByMe, from }) => {
    console.log('signalListener', data);
    if (data?.from === 'participants') {
      if (data.isHandRaised) {
        dispatch({
          type: HAND_RAISED,
          payload: {
            vonageParticipantId: data.sessionData.connection.id,
          },
        });
      } else {
        dispatch({
          type: HAND_UNRAISED,
          payload: {
            vonageParticipantId: data.sessionData.connection.id,
          },
        });
      }
    } else {
      const date = moment(new Date().getTime()).format('HH:mm');
      addMessageToList(data, isSentByMe, from, date);
    }
  }, []);

  const removeEmoji = (node, element) => {
    document.getElementById(element).removeChild(node);
  };

  const emojiHandler = React.useCallback(
    ({ data, isSentByMe, from }) => {
      console.log('emojiHandler', data);
      const elementToInsertEmoji = isSentByMe
        ? 'MP_camera_publisher_default_controls'
        : from.camera.id;
      const node = document.createElement('div');
      const node1 = document.createElement('div');

      if (!state.raiseHand) {
        document
          .getElementById(elementToInsertEmoji)
          .removeChild(document.getElementsByClassName('text')[0]);
      } else {
        node1.appendChild(document.createTextNode(EMOJIS[data]));
        node1.classList.add('text');
        document.getElementById(elementToInsertEmoji).appendChild(node1);

        node.appendChild(document.createTextNode(EMOJIS[data]));
        node.classList.add('emoji');
        document.getElementById(elementToInsertEmoji).appendChild(node);
      }

      !isSentByMe && toast(`${from?.name} raised hand!`);

      node.addEventListener('animationend', (e) => {
        removeEmoji(e.target, elementToInsertEmoji);
      });
    },
    [state.raiseHand]
  );

  const addMessageToList = React.useCallback((data, isSentByMe, from, date) => {
    console.log('addMessageToList', data);
    setListOfMessages((prev) => [...prev, { data, isSentByMe, from, date }]);
  }, []);

  React.useEffect(() => {
    if (room) {
      console.log('listner connected');
      room.on('signal', (data, type, active) => {
        console.log('message received from signal', data, type, active);
        if (data?.data?.type === 'roleChange') {
          if (data?.data?.data?.role === 'Viewer') {
            sessionStorage.removeItem('roleId');
          } else {
            sessionStorage.setItem('roleId', data?.data?.data?.paramUserId);
          }
        }
      });
      room.on('signal:text', signalListener);
      room.on('signal:emoji', emojiHandler);
    }
    return function cleanup() {
      if (room) {
        room.off('signal:text', signalListener);
        room.off('signal:emoji', emojiHandler);
      }
    };
  }, [room, signalListener, emojiHandler]);

  return {
    sendSignal,
    listOfMessages,
  };
}
